module.exports = __webpack_public_path__ + "static/media/sofiLogo.804a6c45.png";